module.exports = __webpack_public_path__ + "static/media/logo.e36f2058.gif";